import ReactMarkdown from 'react-markdown';
import rehypeKatex from "rehype-katex";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import { withOverrideProps } from "./lib";
import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';

function Markdown(props: ReactMarkdownOptions) {
    return ReactMarkdown(props);
}

export const VisualizationMarkdown = withOverrideProps(Markdown, {
    remarkPlugins: [remarkGfm],                     // Remark plugin is github flavored markup for tables etc.
    rehypePlugins: [rehypeRaw, [rehypeSanitize, {   // Rehype is for: First we want to allow HTML then
        ...defaultSchema,                           // we sanitize the HTML with settings that allow math div tags
        attributes: {
          ...defaultSchema.attributes,
          div: [
            ...(defaultSchema.attributes?.div || []),
            ['className', 'math', 'math-display']
          ],
          span: [
            ...(defaultSchema.attributes?.span || []),
            ['className', 'math', 'math-inline']
          ]
        }
      }], rehypeKatex]                              // , then we use Katex to transform formulas.
});
     
